import { select, call, fork, put, delay } from 'redux-saga/effects';
import { selectDeviceReady } from '../../state/device/deviceSlice';
import { fetchContactSaga } from '../contact/fetchContact/fetchContact';
import { fetchCallHistorySaga } from '../callHistory/fetchCallHistory/fetchCallHistory';
import { fetchMessageSessionSaga } from '../message/fetchMessageSession/fetchMessageSession';
import { loadPinnedMessageSessionSaga } from '../message/loadPinnedMessageSession/loadPinnedMessageSessionSaga';
import { fetchVoicemailSaga } from '../voicemail/fetchVoicemail/fetchVoicemail';
import connectSocketSaga from '../socket/connectSocket/connectSocket';
import { connectSseAction } from '../sse/connectSse/action';
import { fetchCallParkSaga } from '../callPark/fetchCallPark/fetchCallPark';
import { fetchCallQueueSaga } from '../callQueue/fetchCallQueue/fetchCallQueue';
import { loadAudioDeviceSaga } from '../audioDevice/loadAudioDevice/loadAudioDevice';
import { loadNotificationsAction } from '../notification/loadNotifications/action';
import { fetchCrmCatalogSaga } from '../integration/fetchCrmCatalog/fetchCrmCatalog';
import { setSystemSuspending, selectLogin } from '../../state/login/loginSlice';
import { initUASaga } from '../userAgent/initUA/initUA';
import { broadcastChannelSaga } from '../broadcastChannel/broadcastChannel';
import { ensurePermission } from '../../browser/notifications';

export function* postLoginSaga() {
    const { isSuspending } = yield select(selectLogin);

    const isActiveInstance = yield call(broadcastChannelSaga);
    if (!isActiveInstance) return;

    // Request notification permission up front so call/message notifications
    // don't race a permission prompt when the first event arrives. Forked:
    // the prompt can stay open while post-login continues.
    yield fork(ensurePermission);

    yield fork(fetchContactSaga);
    yield fork(fetchCallHistorySaga);
    yield call(loadPinnedMessageSessionSaga);
    yield fork(fetchMessageSessionSaga);
    yield put(loadNotificationsAction());
    yield fork(fetchVoicemailSaga);
    yield fork(connectSocketSaga);
    yield put(connectSseAction());
    yield fork(fetchCrmCatalogSaga);
    yield fork(fetchCallParkSaga);
    yield fork(fetchCallQueueSaga);
    yield fork(loadAudioDeviceSaga);

    console.log('Waiting for device to become ready...');

    // Poll until ready
    while (!(yield select(selectDeviceReady))) {
        yield delay(200);
    }

    if (isSuspending) {
        console.log('Resuming from system suspend - skipping UA initialization');
        yield put(setSystemSuspending(false));
    } else {
        console.log('Normal login - initializing UA');
        yield call(initUASaga);
    }

}